export default function isFunction(object) {
  return typeof object === 'function';
}
